import {makeAutoObservable} from "mobx";
import {IPriceInStore, PriceInStore} from "./priceInStore";

export interface IPriceStore {
    clearStore: () => void;
    createPriceList: () => void;
    removePriceList: (priceListId: number) => void;

    priceList: IPriceInStore[];
}

export class PriceStore implements IPriceStore {
    _priceList: IPriceInStore[] = [];

    constructor() {
        makeAutoObservable(this);

        this.createPriceList();
    }

    createPriceList() {
        this._priceList.push(new PriceInStore());
    }

    removePriceList(priceListId: number) {
        this._priceList.splice(priceListId, 1);
    }

    clearStore() {
        this._priceList = [];

        this.createPriceList();
    }

    get priceList() {
        return this._priceList;
    }
}